import { useState } from "react"
import { Input } from "web/components/Form/Controls"
import { TileSizeSelectors } from "web/components/Tiles"
import TileWizardActions from "web/components/AddTileWizard/TileWizardActions"

export function TileRichTextSettingsModal({
  backButtonHandler,
  close,
  overview,
  tile,
  tileEntry,
}) {
  const [title, setTitle] = useState({ value: tile.name })

  const [tileWidth, setTileWidth] = useState({
    value: tileEntry.width,
  })
  const [tileHeight, setTileHeight] = useState({
    value: tileEntry.height,
  })

  async function handleSave() {
    if (
      tileEntry.height !== tileHeight.value ||
      tileEntry.width !== tileWidth.value
    ) {
      await overview.update({
        [overview.type]: {
          tile_entries_attributes: [
            {
              id: tileEntry.id,
              height: tileHeight.value,
              width: tileWidth.value,
            },
          ],
        },
      })
    }

    if (title && title.value && /\S/.test(title.value)) {
      await tile.update({
        overview_tile: {
          name: title.value.trim(),
        },
      })
    }

    close()
  }

  return (
    <>
      <div className="modal-content-above-commands">
        <div className="grid gap-y-5">
          <Input label="Title" value={title} onChange={setTitle} />
          <TileSizeSelectors
            tileWidth={tileWidth}
            tileHeight={tileHeight}
            setTileHeight={setTileHeight}
            setTileWidth={setTileWidth}
          />
        </div>
      </div>
      <TileWizardActions
        onSaveHandler={handleSave}
        backButtonHandler={backButtonHandler}
      />
    </>
  )
}
